__turbopack_context__.v({
  "attribution": "RichContentBlock-module-scss-module__6OWy4a__attribution",
  "blockquote": "RichContentBlock-module-scss-module__6OWy4a__blockquote",
  "bodyColumn": "RichContentBlock-module-scss-module__6OWy4a__bodyColumn",
  "bodyColumnWide": "RichContentBlock-module-scss-module__6OWy4a__bodyColumnWide",
  "cite": "RichContentBlock-module-scss-module__6OWy4a__cite",
  "column": "RichContentBlock-module-scss-module__6OWy4a__column",
  "headingColumn": "RichContentBlock-module-scss-module__6OWy4a__headingColumn",
  "headingRight": "RichContentBlock-module-scss-module__6OWy4a__headingRight",
  "image": "RichContentBlock-module-scss-module__6OWy4a__image",
  "imageCopy": "RichContentBlock-module-scss-module__6OWy4a__imageCopy",
  "inner": "RichContentBlock-module-scss-module__6OWy4a__inner",
  "innerImage": "RichContentBlock-module-scss-module__6OWy4a__innerImage",
  "innerSingle": "RichContentBlock-module-scss-module__6OWy4a__innerSingle",
  "media": "RichContentBlock-module-scss-module__6OWy4a__media",
  "mediaLink": "RichContentBlock-module-scss-module__6OWy4a__mediaLink",
  "quotationMark": "RichContentBlock-module-scss-module__6OWy4a__quotationMark",
  "quote": "RichContentBlock-module-scss-module__6OWy4a__quote",
  "quoteColumn": "RichContentBlock-module-scss-module__6OWy4a__quoteColumn",
  "quoteRow": "RichContentBlock-module-scss-module__6OWy4a__quoteRow",
  "quoteText": "RichContentBlock-module-scss-module__6OWy4a__quoteText",
  "root": "RichContentBlock-module-scss-module__6OWy4a__root",
  "singleColumn": "RichContentBlock-module-scss-module__6OWy4a__singleColumn",
});
